<template>
    <div class="about-container">
      <div class="content-wrapper">
        <div class="text-section animated-text">
          <div v-html="txthtml001"></div>
          <!-- <h1>關於我們</h1>
          <p>
            JiLi 是一家專注於提供高品質保養品的公司。我們的使命是通過天然成分和科學技術相結合，
            為每位用戶提供最適合的護膚解決方案。
          </p>
          <h2>我們的願景</h2>
          <p>
            我們致力於成為保養品行業的領導者，通過不斷創新和改進，讓每個人都能享受到健康、自然的美麗。
          </p>
          <h2>我們的核心價值</h2>
          <ul>
            <li>誠信：我們對每位顧客都坦誠以待，提供真實的信息和產品。</li>
            <li>創新：不斷追求新的技術和配方。</li>
            <li>可持續性：保護地球，從原材料選擇到包裝設計，均注重環境友好。</li>
          </ul>
            -->
        <router-link to="/products" class="explore-products-btn">探索產品</router-link>
      </div>
      
        <div class="image-section animated-image">
            <img
              :src="`${aboutImg000}`"
                 class="about-image"
              loading="lazy"
              :alt="`${$COMPANY_NAME} (${$COMPANY_NAMEn}) 關於我們`"
            />
        </div>
      </div>
    </div>
  </template>
  

<script setup>
import { ref, onMounted,nextTick } from 'vue'
import { useAboutStore } from '@/store/aboutStore.js'
// 若您想保留元件 name，可用 defineOptions (Vue 3.3+):
import { defineOptions } from 'vue'
defineOptions({ name: 'AboutPage' })

// 1. 取得 store
//const store = useStore()

const txthtml001 = ref('')
const aboutImg000 = ref('')


// IntersectionObserver 變數設在外面方便重用
let observer = null

// 2. 以 computed 包裹 getters
//const imagePath = computed(() => store.getters.imagePath)

// 3. onMounted 取代原本 mounted()
onMounted(async () => {

  // 4. 取得關於我們資料
  const aboutStore = useAboutStore()
  await aboutStore.fetchAboutData()
  txthtml001.value = aboutStore.txthtml001
  aboutImg000.value = aboutStore.aboutImg000
  await nextTick()
  initObserver()
})

function initObserver() {
  if (!observer) {
    const observerOptions = { threshold: 0.1 } // 10% 可見時觸發
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
        }
      })
    }, observerOptions)
  }
  // 移除舊觀察可能可自行視需求處理
  // 重新抓取 .animated-text, .animated-image
  document.querySelectorAll('.animated-text, .animated-image').forEach((el) => {
    // 若已經有 visible 就跳過 or 重新 observe
    if (!el.classList.contains('visible')) {
      observer.observe(el)
    }
  })

  // 監聽 txthtml002 的改變 -> DOM 更新後 -> 重新 initObserver
  // watch(aboutImg000, async () => {
  //   await nextTick()
  //   initObserver()
  // })
}


</script>


  <style scoped>
  /* 新增探索產品按鈕樣式 */
  .about-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  </style>
<style coped>
.explore-products-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #ff6600; /* 健康的綠色 */
  color: white;
  text-decoration: none;
  font-weight: bold;
  border-radius: 5px;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.explore-products-btn:hover {
    background-color: #b14801; /* 橙金色 */
  transform: scale(1.05);
}

.content-wrapper {
    display: flex;
    flex-wrap: wrap; /* 為了讓小螢幕時能堆疊 */
    gap: 20px; /* 左右內容間距 */
    align-items: center;
  }
  
  /* 左側文字區域 */
  .text-section {
    flex: 1;
    min-width: 300px;
    padding-right: 20px;
    opacity: 0;
    transform: translateX(-50px); /* 初始位置 */
    transition: opacity 0.8s ease, transform 0.8s ease;
  }
  
  .animated-text.visible {
    opacity: 1;
    transform: translateX(0); /* 回到正常位置 */
  }
  
  .text-section h1 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 10px;
  }
  
  .text-section h2 {
    font-size: 1.5rem;
    color: #800000;
    margin-top: 20px;
  }
  
  .text-section p {
    margin-bottom: 15px;
    line-height: 1.8;
    color: #555;
  }
  
  .text-section ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  .text-section ul li {
    margin-bottom: 10px;
  }
  
  /* 右側圖片區域 */
  .image-section {
    flex: 1;
    min-width: 300px;
    text-align: center;
    opacity: 0;
    transform: scale(0.8); /* 初始大小 */
    transition: opacity 0.8s ease, transform 0.8s ease;
  }
  
  .animated-image.visible {
    opacity: 1;
    transform: scale(1); /* 回到正常大小 */
  }
  
  .about-image {
    width: 100%; /* 圖片自適應寬度 */
    max-width: 330px; /* 限制圖片的最大寬度 */
    transition: opacity 1s ease, transform 1s ease, box-shadow 0.5s ease; /* 添加阴影过渡效果 */
    border-radius: 15px; /* 圆角效果 */
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.06); /* 添加柔和阴影 */
    transition: transform 0.3s ease, box-shadow 0.3s ease; /* 滑鼠懸停特效 */
    border: 5px solid #fff; /* 添加白色边框 */
  }
  
  .about-image:hover {
    transform: scale(1.05); /* 放大效果 */
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 增強陰影效果 */
  }
  
  /* 響應式調整 */
  @media (max-width: 768px) {
    .content-wrapper {
      flex-direction: column; /* 小螢幕時，文字和圖片垂直排列 */
    }
  
    .text-section {
      padding-right: 0;
    }
  
    .about-image {
      max-width: 300px;
    }
  }

</style>
  